import type { ReadonlyDeep } from 'type-fest';

import { ResolvableServiceUsageSettingsInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';

import { resolvableBooleanForm2ApiMapper } from '../../ResolvableField/mappers/resolvable-boolean.form2api.mapper';

import type { ResolvableServiceUsageForm_ResolvableServiceUsage } from '../fragments/resolvable-service-usage.fragment';

export function resolvableServiceUsageSettingsForm2ApiMapper(
  resolvableServiceUsageSettings: NonNullable<
    ReadonlyDeep<ResolvableServiceUsageForm_ResolvableServiceUsage>['settings']
  >,
): ReadonlyDeep<ResolvableServiceUsageSettingsInput> {
  const resolvableServiceUsageSettingsInput = pruneInput(
    resolvableServiceUsageSettings,
    ResolvableServiceUsageSettingsInput,
  );

  return {
    ...resolvableServiceUsageSettingsInput,
    showAmountsInQuotation: resolvableBooleanForm2ApiMapper(
      resolvableServiceUsageSettings.showAmountsInQuotation,
    ),
    showCostsInQuotation: resolvableBooleanForm2ApiMapper(
      resolvableServiceUsageSettings.showCostsInQuotation,
    ),
    showMaterialsInQuotation: resolvableBooleanForm2ApiMapper(
      resolvableServiceUsageSettings.showMaterialsInQuotation,
    ),
    showQuantitiesInQuotation: resolvableBooleanForm2ApiMapper(
      resolvableServiceUsageSettings.showQuantitiesInQuotation,
    ),
  };
}
